module.exports = __webpack_public_path__ + "media/images/fastweb-logo-8a5e3be3.svg";